<template>
  <div class="report-filter report-parent">
    <div class="ms-help">Родительский проект:</div>
    <i-select v-model="parent" style="width: 160px" filterable>
      <i-option
        v-for="item in projects"
        :value="item.id"
        :label="`${item.name}`"
        :key="item.id"
      >
        <span class="report-parent__option">
          {{ getName(item) }}
        </span>
      </i-option>
    </i-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      projects: [{ id: 'all', name: 'Все' }]
    }
  },
  computed: {
    parent: {
      get () {
        return this.$store.state.reports.parent
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'parent',
          value
        })
      }
    }
  },
  async created () {
    try {
      const url = `page/project?order=code_asc`
      const data = await this.$store.dispatch('GET_REQUEST', { url })

      this.projects = [
        { id: 'all', name: 'Все' },
        ...data
      ]
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    getName ({ id, name, code }) {
      if (id === 'all') return name

      return `${code}. ${name}`
    }
  }
}
</script>

<style lang="less">
.report-parent {
  display: flex;
  align-items: center;

  .ms-help {
    margin-right: 8px;
  }

  &__option {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 720px;
  }
}
</style>
